export const stringToNumber = (value: any) => {
    if (typeof value === "number") return value;
    if (typeof value !== "string") return 0;
    if (value === undefined || value === null) return 0;

    let stringValue = value;

    if (stringValue.indexOf("R$ ") >= 0) {
        stringValue = stringValue.replace("R$ ", "");
    }
    if (stringValue.indexOf(",") >= 0) {
        stringValue = stringValue.replace(/\./g, "").replace(/,/g, ".");
    }

    const valueNumber = Number.parseFloat(stringValue);

    return Number.isNaN(valueNumber) ? 0 : valueNumber;
};

export const toKebabCase = (text: string) =>
    text.replace(/[A-Z]+(?![a-z])|[A-Z]/g, ($, ofs) => (ofs ? "-" : "") + $.toLowerCase());

export const toCamelCase = (text: string) => text.replace(/-\w/g, (string) => string.replace(/-/, "").toUpperCase());

export const removeNonNumeric = (value: string, options: { allowNegative?: boolean } = {}): string => {
    if (!value) return "";

    const { allowNegative = false } = options;

    const nonNumericRegex = new RegExp(/\D/g);
    const sanitizedValue = value.replace(nonNumericRegex, "");
    const isNegative = allowNegative && value.startsWith("-");

    return isNegative ? `-${sanitizedValue}` : sanitizedValue;
};

export const formatMoney = (value: string | number): string => {
    const decimalPlace = 2;

    const valueAsString = value.toString();
    const valueAsNumber = Number(value);

    const fullNumber = parseInt(valueAsString, 10);

    let fixedNumber: string;

    if (Number.isNaN(valueAsNumber)) {
        fixedNumber = (0).toFixed(decimalPlace);
    } else {
        fixedNumber = valueAsNumber.toFixed(decimalPlace);
    }

    const decimalPoint = ",";
    const numberDivisor = ".";
    const prefix = fullNumber < 0 ? "-" : "";
    const numberWithoutDecimalPlace = parseInt(fixedNumber, 10).toString();

    const firstPartDecimalPlaces = numberWithoutDecimalPlace.length > 3 ? numberWithoutDecimalPlace.length % 3 : 0;

    let wholeNumberPart = "";

    if (firstPartDecimalPlaces) {
        wholeNumberPart += numberWithoutDecimalPlace.substring(0, firstPartDecimalPlaces) + numberDivisor;
    }

    wholeNumberPart += numberWithoutDecimalPlace
        .substring(firstPartDecimalPlaces)
        .replace(/(\d{3})(?=\d)/g, `$1${numberDivisor}`);

    const decimalPlacePart =
        decimalPoint +
        Math.abs(valueAsNumber - parseInt(numberWithoutDecimalPlace, 10))
            .toFixed(decimalPlace)
            .slice(2);

    return prefix + wholeNumberPart + decimalPlacePart;
};

export const removeLeadingZeros = (value: string, options: { allowNegative?: boolean } = {}): string => {
    if (!value) return "";

    const { allowNegative = false } = options;
    const isNegative = allowNegative && value.startsWith("-");

    const valueToSanitize = removeNegativeSign(value);
    const sanitizedValue = valueToSanitize.replace(/^0+(?!$)/, "");

    return isNegative ? `-${sanitizedValue}` : sanitizedValue;
};

export const removeNegativeSign = (value: string): string => {
    if (!value) return "";

    return value.replace(/^-/, "");
};

export const convertToDecimalFormat = (
    value: string,
    options: { decimalPrecision?: number; allowNegative?: boolean } = {}
): string => {
    if (!value) return "";

    const { decimalPrecision = 0, allowNegative = false } = options;

    const isNegative = allowNegative && value.startsWith("-");
    const valueWithoutNegativeSign = removeNegativeSign(value);
    const integerPartLength = valueWithoutNegativeSign.length - decimalPrecision;

    const integerPart = integerPartLength > 0 ? valueWithoutNegativeSign.slice(0, integerPartLength) : "0";
    const decimalPart = valueWithoutNegativeSign.slice(Math.max(0, integerPartLength)).padStart(decimalPrecision, "0");

    const formattedValue = `${integerPart},${decimalPart}`;

    return isNegative ? `-${formattedValue}` : formattedValue;
};
